module.exports = __webpack_public_path__ + "static/media/lucky_go.295b5dda.mp3";